import { render, staticRenderFns } from "./ComplaintNewPopup.vue?vue&type=template&id=0c24e5c8&scoped=true&"
import script from "./ComplaintNewPopup.vue?vue&type=script&lang=js&"
export * from "./ComplaintNewPopup.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintNewPopup.vue?vue&type=style&index=0&id=0c24e5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24e5c8",
  null
  
)

export default component.exports